import React, { useEffect } from 'react';
import { Card, CardBody, CardHeader, Table } from 'reactstrap';
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from 'react-redux';
import { fetchInstallDeviceAnalytics } from '../../../../slices/veloxity/adminAnalytics/getInstallDeviceAnalyticsSlice';

const InstallDeviceAnalytics = ({ licenseKey }) => {
    const dispatch = useDispatch();
    const installDeviceData = useSelector((state) => Array.isArray(state.installDeviceAnalytics?.data) ? state.installDeviceAnalytics.data : []);
    const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--vz-primary').trim();
    const secondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--vz-secondary').trim();
    const infoColor = getComputedStyle(document.documentElement).getPropertyValue('--vz-info').trim();

    useEffect(() => {
        if (licenseKey) {
            dispatch(fetchInstallDeviceAnalytics(licenseKey));
        }
    }, [dispatch, licenseKey]);

    const series = [{
        name: "New Device Count",
        type: 'area',
        data: installDeviceData.map(item => item.newDeviceCount),
    }];

    const options = {
        chart: {
            height: 370,
            type: "area",
            toolbar: { show: false },
        },
        colors: [primaryColor, secondaryColor, infoColor], 
        stroke: {
            curve: "smooth",
            width: 2,
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 90, 100]
            }
        },
        markers: {
            size: 4,
            strokeWidth: 2,
            hover: { size: 6 },
        },
        xaxis: {
            categories: installDeviceData.map(item => item.date), 
            title: { text: 'Date' },
            labels: {
                rotate: -45, 
                format: 'yyyy-MM-dd' 
            }
        },
        yaxis: {
            title: { text: 'New Device Count' },
            labels: {
                formatter: (val) => val.toLocaleString('en-US'),
            },
        },
        grid: {
            show: true,
            xaxis: { lines: { show: true } },
            yaxis: { lines: { show: false } },
            padding: { top: 0, right: -2, bottom: 15, left: 10 },
        },
        legend: {
            show: true,
            horizontalAlign: "center",
            offsetX: 0,
            offsetY: -5,
            markers: { width: 9, height: 9, radius: 6 },
            itemMargin: { horizontal: 10, vertical: 0 },
        },
        tooltip: {
            shared: true,
            y: {
                formatter: (val) => val.toLocaleString('en-US'),
            },
        },
    };

    return (
        <Card>
            <CardHeader className="align-items-center d-flex" style={{ padding: '25px 15px' }}>
                <h4 className="card-title mb-0 flex-grow-1">Install New Device Analytics</h4>
            </CardHeader>

            <CardBody>
                <div className="apex-charts" style={{ height: '40vh' }}>
                    <ReactApexChart
                        options={options}
                        series={series}
                        type="area"
                        height="100%"
                        className="apex-charts"
                    />
                </div>

            </CardBody>
        </Card>
    );
};

export default InstallDeviceAnalytics;
